<template>
    <div class="main-content no-padding noscroll">
        <div class="funnel_apps layout-column noscroll" v-if="funnel">
            <div class="funnel_apps_header">
                <h3>Settings</h3>
                <div class="right_btns">
                  <v-button @click="closeSettings" border label="Cancel" />
                  <v-button @click="saveChanges" label="Save changes" :loading="saving" />
                </div>
            </div>

          <div class=" scroll">
          <div class="funnel_apps_list ">
                <div class="brdr_content_wrpr">
                  <h3 class="brdr_content_title">Basic settings</h3>

                  <InputField label="Funnel name" v-model="funnel.name" required></InputField>

                    <div class="form-group with_top_block" style="margin-top: 25px;">
	                    <input-field label="Funnel URL" readonly is-copy v-model="thisFunnelUrl" />
                    </div>
                    <div class="layout-row funnel_domain_inputs">
                      <select-field class="flex "
                            :options="domains"
                            label="name"
                            caption="Funnel domain"
                            :reduce="d => d.id"
                            :loading="loadingDomains"
                                    dense
	                           v-model="funnel.domain_id">
                        </select-field>
	                    <v-button class="connect-domain-btn" slim border :disabled="!canConnectDomains"
	                              label="Connect a new domain" @click="getConnectNewDomainPopup = true" ></v-button>
	                    <v-button class="connect-domain-btn" slim border :disabled="!canConnectDomains"
	                              label="Manage..." @click="domainsPopupOpen=true" ></v-button>
                    </div>
	                <div>
		                <div class="alert_box orange margin-t-10" v-if="!canConnectDomains">
			                <div class="icon">
				                <inline-svg :src="require('@/assets/img/warning_icon.svg')" />
			                </div>
			                <div>
				                <router-link to="/settings/billing/choose-your-plan">
					                Upgrade your account
				                </router-link>
				                to a <b>Funnelish™ Plus</b> plan to use your custom domains.
			                </div>
		                </div>
	                </div>

	                <div style="height: 20px"></div>
                  <InputField label="Path (optional)"
                              :prepend="funnelDomainName"
                              v-model="funnel.path"></InputField>
                </div> <!-- Basic settings -->

	          <sms-numbers-settings :funnel="funnel" />

	          <tracking-codes-settings :funnel="funnel" />

	          <div class="brdr_content_wrpr">
		          <h3 class="brdr_content_title">Payment settings</h3>
		          <div class="form-group with_top_block">
			          <span class="form_group_top_block">Currency</span>

			          <v-select label="text" :reduce="x=>x.id" :clearable="false" :searchable="true"
			                    :options="selectCurrencyOptions" v-model="funnel.currency_code"
			                    append-to-body>
				          <template v-slot:option="option">
					          <span v-html="option.text"></span>
				          </template>
				          <template v-slot:selected-option="option">
					          <span v-html="option.text"></span>
				          </template>
			          </v-select>
		          </div>
		          <v-switch label="Enable test mode?" :value="funnel.test_mode"
		                    v-model="funnel.test_mode">
			          <template v-slot:info>
				          <p style="font-weight: 600;">Test mode</p>
				          <p>
					          This allows you to make test purchases and optins without making real payments.
				          </p>
			          </template>
		          </v-switch>

		          <input-field v-model="funnel.statement_descriptor"
		                       class="margin-t-25" label="Statement descriptor" optional
		                       :maxLength="22" />
	          </div>

	          <email-settings :funnel="funnel" />
	          <favicon-settings :funnel="funnel" />

	          <div class="brdr_content_wrpr">
		          <h3 class="brdr_content_title">Share funnel</h3>

		          <div class="form-group with_top_block" style="margin-top: 25px;">
			          <input-field label="Your funnel share URL" readonly is-copy v-model="shareUrl" />
		          </div>
		          <div class="alert_box blue">
			          <span class="icon">
                  <inline-svg :src="require('@/assets/img/info_icon.svg')"/>
              </span>
			          <span>Add <code>&ref=<b>{your referral code}</b></code> at the end of the above URL, to get commissions
				          for any signups from your shared funnels.
				          <a href="https://funnelish.tapfiliate.com/" target="_blank">Check our affiliate program to learn more.</a>
			          </span>
		          </div>
	          </div>


                <div class="brdr_content_wrpr danger_box">
                    <h3 class="brdr_content_title">Danger zone!</h3>
                    <p>Be careful! this action is irreversible. Steps, products and other funnel data will get archived.</p>
                    <div class="layout-row">
	                    <v-button label="Delete this funnel!" border red @click="showFunnelDeletePopup" />
                    </div>
                </div>
            </div>
          </div>
        </div>

	    <portal to="popup" v-if="deleteFunnelOpen">
		    <delete-funnel-popup :funnel="funnel" @close="deleteFunnelOpen=false" @done="removeFunnel" />
	    </portal>

	    <ConnectNewDomainPopup v-if="getConnectNewDomainPopup" @close="closeConnectNewDomainPopup" @done="pushNewDomain"/>
	    <domains-popup v-if="domainsPopupOpen" @close="domainsPopupOpen=false; loadDomains();"  />
    </div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";
import Loading from "@/components/Loading.vue"
import FunnelDeletePopup from "@/components/popups/FunnelDeletePopup.vue"
import API from "@/api"
import {mapGetters} from "vuex"
import currencies from "@/helpers/currencies"
import Tooltip from "@/components/Tooltip.vue"
import InputField from "@/components/base/input-field";
import EmailSettings from "@/views/funnels/funnel/settings/email-settings";
import VSwitch from "@/components/base/v-switch";
import VButton from "@/components/base/v-button";
import SelectField from "@/components/base/select-field";
import ConnectNewDomainPopup from "@/components/popups/domains/connect-new-domain-popup";
import DomainsPopup from "@/components/popups/domains/domains-popup";
import FaviconSettings from "@/views/funnels/funnel/settings/favicon-settings";
import TrackingCodesSettings from "@/views/funnels/funnel-plus/funnel/tracking-codes-settings";
import SmsNumbersSettings from "@/views/funnels/funnel-plus/funnel/sms_numbers/sms_numbers_settings";
import DeleteFunnelPopup from "@/views/funnels/DeleteFunnelPopup";

export default {
    name: "FunnelSettings",
    components: {
	    DeleteFunnelPopup,
	    SmsNumbersSettings,
	    TrackingCodesSettings,
	    FaviconSettings,
	    DomainsPopup,
	    ConnectNewDomainPopup,
      SelectField,
      VButton,
      VSwitch,
      EmailSettings,
      InputField,
        MainSearch,
        Loading,
        FunnelDeletePopup,
        Tooltip,
    },
    mixins: [API],
    data: function() {
        return {
	        deleteFunnelOpen:false,
	        loadingDomains: false,
	        domainsPopupOpen: false,
          saving: false,
          loading: true,
          selectCurrencyOptions: currencies,
          funnel: [],
          stepData: [],
          funnelOld: [],
          // domain: {
          //     selected: '',
          //     options: []
          // },
          getConnectNewDomainPopup: false,
          domains: [],
        };
    },
    computed: {
        ...mapGetters(["getFunnelStore"]),
	    user() {
        	return this.$store.state.userInfo;
	    },
	    canConnectDomains() {
		    return this.user && this.user.plan_key &&
				    this.user.plan_key !== 'funnelish-apps' &&
				    this.user.plan_key.indexOf('trial') < 0;
	    },
	    userId() {
            return this.$store.state.userInfo.id
        },
      selectedDomainId() {
          return this.funnel.domain_id;
      },
      selectedDomain() {
        return this.domains.length>0 ? this.domains.filter(d => d.id===this.selectedDomainId)[0] : {};
      },
      funnelDomainName() {
        if (!this.selectedDomainId || !this.selectedDomain || !this.selectedDomain.name)
          return '/'
        else
          return 'https://'+this.selectedDomain.name;
      },
      thisFunnelUrl() {
        if (!this.selectedDomainId || !this.selectedDomain || !this.selectedDomain.name)
          return 'Please set a domain';
        else {
          let path = 'https://' + this.selectedDomain.name;

          if (this.funnel.path && this.funnel.path.length >= 1)
            path += '/' + this.funnel.path;
          return path;
        }
      },
	    shareUrl() {
		    return window.location.origin + `/share?funnel=${this.funnel.id}&code=${this.funnel.share_code}`
	    }
    },
    methods: {
        pushNewDomain(val){
        	this.loadDomains();
        },
        closeConnectNewDomainPopup(){
            this.getConnectNewDomainPopup = false;
        },
        showFunnelDeletePopup() {
            this.deleteFunnelOpen=true
        },
        async removeFunnel() {
            this.$router.push({path: '/funnels'});
        },
        async saveChanges() {
          try {
            this.saving = true;
            let result = await this.api.funnels.patch(this.funnel.id, this.funnel)

            this.$router.push({path: '/wfunnel/' + this.$route.params.id});
            this.$store.dispatch('setFunnelStore', result);
          } catch (e) {
            this.$error(e)
          } finally {
            this.saving = false;
          }
        },
        async init(id) {
            this.funnel = this.getFunnelStore;
            this.loading = false;
            let safeString = JSON.stringify(this.funnel);
            this.funnelOld = JSON.parse(safeString);

            this.loadDomains();
        },
	    async loadDomains() {
        	try {
        		let oldDomainId = this.funnel.domain_id;
		        this.domains = [];
		        this.loadingDomains = true;
		        this.domains = await this.api.wsteps.getAllDomains();
		        this.funnel.domain_id = this.funnelOld.domain_id;
	        } catch (e) {
		        console.error("ERROR", e);
		        this.$notify({
			        type:"warn",
			        group: "main",
			        title: "Something went wrong... Please try again later",
		        });
	        } finally {
		        this.loadingDomains = false;
	        }

	    },
        closeSettings() {
            this.$store.dispatch('setFunnelStore', this.funnelOld);
            this.$router.push({path: '/wfunnel/'+this.$route.params.id});
        }
    },
    created() {
        let {id} = this.$route.params;
        this.init(id);
    },
}
</script>
<style lang="scss" scoped>
.alert_box .icon {
	width: 22px;
	height: 22px;
	margin-right: 11px;
}
.funnel_domain_inputs {
	align-items: center;
}

.funnel_domain_inputs > div:first-child {
    width: 100%;
    flex: 1;
    padding-right: 15px;
}

.funnel_domain_inputs > .button:last-child {
    //padding: 9px 20px
	margin-left: 10px;
}

</style>
